// This JavaScript file is created by Cision and holds settings for all our client modules.
// This file works as a config file for all the modules and here you will find general settings 
// and a specific sektion for each module with its access key that is used to fetch the data from our API. 

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.settings = cision.websolution.settings || {};

cision.websolution.settings = {
    general: {
        // Settings that apply to all modules 
        serviceEndpoint: 'https://publish.ne.cision.com/papi/',
        uiLanguage: 'en',
        useProxyHandler: false,
        // proxyHandler: 'ProxyCallsHttpHandler.ashx',
        startDate: '',
        endDate: '',
        pageIndex: 0,
        pageSize: 50,
        numberFormatOptions: {
            thousandSeparator: ' ',
            decimalSeparator: ',',
            decimalPrecision: 2
        },
        dateFormatOptions: {
            dateTimeFormat: 'DD MMM YYYY HH:mm',
            dateFormat: 'DD MMM YYYY',
            timeFormat: 'HH:mm'
        },

        // Newsfeed specific settings
        separateFirstRelease: false,
        introMaxLength: 155,
        titleMaxLength: null,
        newsfeedYearsStartYear: 1980,

        // ownership specific settings
        LargestPieShowCount: 25,
        LargestListShowCount: 25,

        // Calendar specific settings
        separateFirstEvent: false,

        // Printed Material specific settings
        printedMaterialCategory: '',
        maxAmountOfItems: 10, // max amount of items a user can order in one request

        // Ticker specific settings
        tickerImageMinus: "Images/down.png",
        tickerImagePlus: "Images/up.png",
        tickerImageUnchanged: "Images/unadjusted.png",

        //Share calculator specific settings
        startDateYear: 2007,

        // Sharegraph specific settings
        chartContainerId: 'sharegraph-container',
        chartTitle: '',
        backgroundImage: '',
        lineWidth: 2,
        gridLineWidth: 0,
        plotBackgroundColor: 'white',
        plotBorderWidth: 0,
        defaultSeriesType: 'spline', //area, areaspline, bar, column, line, pie, scatter, spline, candlestick or ohlc, arearange, areasplinerange and columnrange.
        chartComparison: 'none', /* Default comparison type */
        typeOfChart: 'EndOfDay',
        showVolume: true,
        showHorisontalTicker: true,
        useHighchartsElements: false, // enabling highcharts own exports and range selectors, can be used if cisions custom ones are removed 
        enableLegend: false,
        enableScrollbar: false,
        enableNavigator: true,
        dividendType: 'Annual', // Annual, Bonus, Monthly, Quarterly, HalfYear 
        effectiveYieldSuffix: 'EFFECTIVEYIELD',
        yAxisSize: { share: { top: 0, height: 250 }, volume: { top: 300, height:80 } }, // sizes for the share graph and the volume graph. only applies when volume is displayed
        mainInstruments: [ /* Array of instruments to consider primary while others become Peers and Indexes */
            { symbol: 'DYVOX', marketPlace: 'XSTO', currency: 'SEK', name: 'Dynavox Group', hasEffectiveYield: false }
        ],
        indexInstruments: [
            { symbol: 'OMXSPI', marketPlace: 'XSTO', currency: 'SEK', name: 'OMX Stockholm PI' }
        ],
        peersInstruments: [
            //{ symbol: 'TEL2 B', marketPlace: 'XSTO', currency: 'SEK', name: 'Tele 2' }
        ], 
        instrumentColors: [
            { uniqueKey: 'DYVOXXSTOSEK', preferredColor: '#f27b7b' },
            { uniqueKey: 'OMXSPIXSTOSEK', preferredColor: '#4286f4' },
            { uniqueKey: 'DYVOXXSTOSEKVOLUME', preferredColor: '#c46464' }
        ],
        // Displaying releases, reports, insiders and dividend in the graph.
        // If the indicators should be attached to a line in the graph add correct symbol, marketplace and currency as seriesId otherwise it will stick to the bottom
        // shape = squarepin, flag or circlepin
        indicatorsOnSeries: [
            { uniqueKey: 'Regulatory RPT', translationKey: 'TextReport', seriesId: 'DYVOXXSTOSEK', shape: 'circlepin', title: 'R', shapeColor: '#f27b7b', shapeOutlineColor: '#f27b7b', shapeTextColor: 'white' },  
            { uniqueKey: 'Regulatory PRM', translationKey: 'TextPress', seriesId: '', shape: 'circlepin', title: 'P', shapeColor: '#f27b7b', shapeOutlineColor: '#f27b7b', shapeTextColor: 'white' },
            //{ uniqueKey: 'INSIDERS', translationKey: 'TextInsider', shape: 'flag', title: 'INS', shapeColor: '#a4c5fc', shapeOutlineColor: '#4970af', shapeTextColor: 'black' },
            { uniqueKey: 'DIVIDEND', translationKey: 'TextDividend', shape: 'squarepin', title: 'U', shapeColor: '#ecefbf', shapeOutlineColor: '#bec18d', shapeTextColor: 'black' }  
        ],
        // Sharegraph releases specific settings
        showReleaseLink: true,
        enableReleasesOnIntraday: true,
        releaseLinkFormatter: 'https://publish.ne.cision.com/Release/ViewReleaseHtml/',

        // Estimates specific settings
        estimateCurrency: '', // should never be necessary, filters out data with specific currency in the same data set 
        field: 'SALES' /* default historical graph choose between SALES/EBIT/DPS/EPS */,
        valuePrefix: '',
        valueSuffix: ' SEK',
        tooltipHeaderEstimate: "Estimate - ",
        tooltipHeaderReal: "Actual - ",
        tooltipDateLabel: "",
        tooltipAmountLabel: "",
        suffixEstimate: ' FC',
        suffixActual: '',
        periodStart: '',
        periodEnd: '',
        dateString: "",
        amountString: "",
        hideEstimateIfActualExists: true,

        //stores data if ownership tab is rendered
        ownershipTabLoaded: [],
        //stores data if estimate tab is rendered
        estimateTabLoaded: [],
        cisionChartsColors: [
            { uniqueKey: 'gray', preferredColor: '#5C5C61' },
            { uniqueKey: 'blue', preferredColor: '#00607f' },
            { uniqueKey: 'orange', preferredColor: '#ff6c36' }
        ]
    }, 

    orderbook: {
        accessKey: 'FFD3EEA985D046F9AB8DBA2FDD95DEED'
    },

    ownership: {
        accessKey: ''
    },

    totalreturn: {
        accessKey: ''
    },

    estimate: {
        accessKey: '',
        accessKeyTicker: ''
    },

    ticker: {
        accessKey: '79C8831A650E4EDA88D63C54E63984F3'
    },

    sharegraph: {
        accessKey: '9D60118C261D4F459AF93DC3D5010590',
        shareHistoryKey: 'D56D796D4BE1417186CBA2BA04438F1B'
    },

    sharecalculator: {        
        accessKey: '8A2CAA61DA0549B483F1955EE75A4743'
    },

    minisharegraph: {
        accessKey: '9D60118C261D4F459AF93DC3D5010590'
    },

    newsfeed: {
        accessKey: 'F6B3D8A32AE54AFAB945F905EB5788A4'
    },

    mediafeed: {
        accessKey: 'F6B3D8A32AE54AFAB945F905EB5788A4'
    },

    insider: {
        accessKey: ''   
    },

    calendar: {
        accessKey: ''
    },

    printedMaterial: {
        accessKey: ''
    }

};

// Switch moment language
try {
    //moment.locale(cision.websolution.settings.general.uiLanguage);
    cision.websolution.settings.general.uiLanguage = Shopify.locale;
    moment.locale(Shopify.locale);
} catch (e) {
    console.log(e);
}

try {
    Highcharts.setOptions({
        lang: {
            decimalPoint: cision.websolution.settings.general.numberFormatOptions.decimalSeparator,
            thousandsSep: cision.websolution.settings.general.numberFormatOptions.thousandSeparator
        }
    });
} catch (e) {
    console.log(e);
}
